export default __webpack_public_path__ + "c36dbe9899ff69222724b2aab9131325.png";